import React, { useEffect, useState } from 'react';
import {Carousel, Button, Modal} from 'react-bootstrap';
import axios from 'axios';
import ad1 from '../img/Annual Day/IMG_5534.JPG'
import ad2 from '../img/Annual Day/IMG_5587.JPG'
import ad3 from '../img/Annual Day/IMG_5605.JPG'
import ad4 from '../img/Annual Day/IMG_5749.JPG'
import ad5 from '../img/Annual Day/IMG_5768.JPG'
import c1 from '../img/career/IMG_7789.JPG'
import c2 from '../img/career/IMG_7814.JPG'
import c3 from '../img/career/IMG_7837.JPG'
import c4 from '../img/career/IMG_7838.JPG'
import c5 from '../img/career/IMG_7839.JPG'
import c6 from '../img/career/IMG_7846.JPG'
import c7 from '../img/career/IMG_7852.JPG'
import cy1 from '../img/Cycles/IMG_8310.JPG'
import cy2 from '../img/Cycles/IMG_8323.JPG'
import cy3 from '../img/Cycles/IMG_8339.JPG'
import cy4 from '../img/Cycles/IMG_8357.JPG'
import cy5 from '../img/Cycles/IMG_8382.JPG'
import cy6 from '../img/Cycles/IMG_8383.JPG'
import cy7 from '../img/Cycles/IMG_8384.JPG'
import cy8 from '../img/Cycles/IMG_8386.JPG'
import './Gallery.css';

const config = require("../config.json");

const posts = [
  {
    id: 1,
    title: 'SCHOOL ANNUAL DAY 2025',
    images: [ad1, ad2, ad3, ad4, ad5],
    excerpt: 'This Accademic Year Annual Day was celebrated on 09th August 2025 with great enthusiasm and joy.'
  },
  {
    id: 2,
    title: 'Career Guidance Program',
    images: [c1, c2, c3, c4, c5, c6, c7],
    excerpt: 'Career guidance sessions to help students choose the right path.'
  },
  {
    id: 3,
    title: 'Cycle Distribution',
    images: [cy1, cy2, cy3, cy4, cy5, cy6, cy7, cy8],
    excerpt: 'New Cycles were distributed to our students on 01 December 2025.'
  },
];

export default function GalleryMain(){
  const [showModal, setShowModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetchGalleryImages();
  }, []);

  const handleViewClick = (post) => {
    setSelectedPost(post);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedPost(null);
  };

   const fetchGalleryImages =async()=>{
    try{
        setLoaded(false);
        const fileName='images/gallery/';
        const bucketName="images.stxaviersthoothukudi.com";
    await axios.get(`${config.api.invokeURL}/dashboard/website/gallery?fileName=${fileName}&bucketName=${bucketName}`,{
        headers: {
          //Authorization: access_token,
          'x-api-key': config.api.key
        }}, 
    ).then((response)=>{
        console.log(response.data);
        processGalleryData(response.data);
        //setGalleryImages(response.data);
        //enqueueSnackbar(response.data.length + " - Project Images are available",{variant:'success'});
        //setLoaded(true);
        //setDispMsg(response.data.length + " - Images are found in your Gallery");
    }).catch((error)=>{
        //console.log(error.message);
        //enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        setLoaded(true);
        //window.scrollTo(0,0);   
        //setDispMsg(error.message);
    })
  }catch(error){
  //console.log(error.message);
    //enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
    setLoaded(true);
    //window.scrollTo(0,0);   
    //setDispMsg(error.message);
  }
  }

  const processGalleryData=(item)=>{
    const test=[];
    for(const i in item){
        var testv={};
        testv=item[i];
        testv.length=item[i].fileName.length;
        testv.id=parseInt(i)+1;
        test.push(testv);
        testv={};
    }
    //console.log("testdata :", test);
    setGalleryImages(test);
    setLoaded(true);
  }

  return (
    <div className="container-fluid py-5 bg-light">
      <div className="container">
        <div className="text-center mb-4">
          <p className="section-title px-5"><span className="px-2">GALLERY</span></p>
          <h1 className="mb-4">Latest Events & Updates</h1>
        </div>

        <div className="row">
          {galleryImages.map((post,id) => (
            <div className="col-md-4 mb-4" key={id}>
              <div className="card border-0 shadow-sm h-100">
                {/* Carousel for multiple images */}
                <Carousel
                  className="blog-carousel"
                  interval={3500}
                  controls={post.fileName.length > 1}
                  indicators={post.fileName.length > 1}
                  fade={true}
                  prevIcon={<span className="carousel-icon"><i className="fa fa-chevron-left"></i></span>}
                  nextIcon={<span className="carousel-icon"><i className="fa fa-chevron-right"></i></span>}
                >
                  {post.fileName.map((img, idx) => (
                    <Carousel.Item key={idx}>
                      <img
                        src={`${config.s3.imageUrl}${img}`}
                        className="d-block w-100"
                        alt={post.projectName + ' - ' + (idx + 1)}
                        style={{ height: '250px', objectFit: 'cover' }}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>

                {/* Card content */}
                <div className="card-body">
                  <h5 className="card-title">{post.projectName}</h5>
                  {/*<p className="card-text">{post.excerpt}</p>*/}
                  <Button variant="primary" onClick={() => handleViewClick(post)}>
                    VIEW
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/*<div className="row">
          {posts.map(post => (
            <div className="col-md-4 mb-4" key={post.id}>
              <div className="card border-0 shadow-sm h-100">
                {/* Carousel for multiple images //
                <Carousel
                  className="blog-carousel"
                  interval={3500}
                  controls={post.images.length > 1}
                  indicators={post.images.length > 1}
                  fade={true}
                  prevIcon={<span className="carousel-icon"><i className="fa fa-chevron-left"></i></span>}
                  nextIcon={<span className="carousel-icon"><i className="fa fa-chevron-right"></i></span>}
                >
                  {post.images.map((img, idx) => (
                    <Carousel.Item key={idx}>
                      <img
                        src={img}
                        className="d-block w-100"
                        alt={post.title + ' - ' + (idx + 1)}
                        style={{ height: '250px', objectFit: 'cover' }}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>

                {/* Card content //
                <div className="card-body">
                  <h5 className="card-title">{post.title}</h5>
                  <p className="card-text">{post.excerpt}</p>
                  <Button variant="primary" onClick={() => handleViewClick(post)}>
                    VIEW
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>*/}
      </div>

      {/* Fullscreen Modal with Carousel */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        fullscreen={true}
        className="blog-fullscreen-modal"
        dialogClassName="modal-fullscreen"
        contentClassName="modal-content-fullscreen"
      >
        <Modal.Body className="blog-modal-body">
          {/* Close Button */}
          <button
            type="button"
            className="blog-close-btn"
            onClick={handleCloseModal}
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>

          {selectedPost && (
            <div className="blog-modal-carousel-container">
              <h2 className="blog-modal-title">{selectedPost?.title}</h2>
              <Carousel
                className="blog-modal-carousel"
                interval={3500}
                controls={selectedPost.images.length > 1}
                indicators={selectedPost.images.length > 1}
                fade={true}
                prevIcon={<span className="carousel-icon"><i className="fa fa-chevron-left"></i></span>}
                nextIcon={<span className="carousel-icon"><i className="fa fa-chevron-right"></i></span>}
              >
                {selectedPost.images.map((img, idx) => (
                  <Carousel.Item key={idx}>
                    <img
                      src={img}
                      className="d-block mx-auto"
                      alt={selectedPost.title + ' - ' + (idx + 1)}
                      style={{ maxWidth: '95%', maxHeight: '90vh', objectFit: 'contain' }}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  )
}
